export enum SecurityOfferedEnum {
  Unsecured = 'unsecured',
  Secured = 'secured',
}
